'use es6';

import { Map as ImmutableMap, List } from 'immutable';
import * as http from 'reporting-data/request/http';
import { transformResponseForChart, transformResponseForTable, getAggregationProps } from './helpers';
import { isTable, translateFilters, isSearch, getQuery } from '../lib/salesAnalytics/helpers';
import { Dataset } from 'reporting-data/v2/dataset/datasetRecords';
import resolveProperties from '../lib/salesAnalytics/resolveProperties';
import generateReferences from '../lib/salesAnalytics/generateReferences';
import { getDrilldownFields } from '../lib/salesAnalytics/drilldownColumns';
const transformSearchResponse = ({
  report,
  response
}) => {
  const responseObjects = response.getIn(['groups', 0, 'objectPage', 'objects']);
  const objects = responseObjects ? responseObjects.toJS().map(({
    object: {
      properties: objectProps,
      objectId
    },
    explanation
  }) => Object.keys(objectProps).reduce((collect, key) => Object.assign({}, collect, {
    objectId,
    [key]: objectProps[key].value
  }), explanation)) : List();
  const datasets = ImmutableMap({
    primary: Dataset({
      data: objects,
      paginationSize: response.getIn(['groups', 0, 'objectPage', 'total'])
    })
  });
  return {
    datasets,
    response,
    report
  };
};
const transformAggregationResponse = ({
  report,
  response
}) => isTable(report) ? transformResponseForTable({
  report,
  response
}) : transformResponseForChart({
  report,
  response
});
const resolveAggregationData = report => {
  if (isTable(report)) {
    return http.post('/sales-reporting/push-analysis/counts-paginated', {
      query: getQuery(report),
      data: {
        config: report.get('config').delete('offset'),
        offset: report.getIn(['config', 'offset'])
      }
    }).then(response => ({
      report,
      response
    }));
  }
  return http.post('/sales-reporting/push-analysis/counts', {
    query: getQuery(report),
    data: report.get('config')
  }).then(response => ({
    report,
    response
  }));
};
const resolveSearchData = report => http.post('/sales-reporting/push-analysis/objects', {
  query: getQuery(report),
  data: {
    config: report.get('config').delete('offset'),
    offset: report.getIn(['config', 'offset'])
  }
}).then(response => ({
  report,
  response
}));
export default (report => isSearch(report) ? translateFilters(report).then(resolveSearchData).then(transformSearchResponse).then(resolveProperties(getDrilldownFields(report))).then(generateReferences).then(({
  datasets
}) => datasets.map(dataset => ImmutableMap({
  data: dataset
}))) : translateFilters(report).then(resolveAggregationData).then(transformAggregationResponse).then(resolveProperties(getAggregationProps(report))).then(generateReferences).then(({
  datasets
}) => datasets.map(dataset => ImmutableMap({
  data: dataset
}))));